// Dev-only error logging; no-ops in production to keep the console clean
// while preserving non-empty catch blocks (no silent failures).
export function logError(...args) {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
}
